export default __webpack_public_path__ + "static/media/preview_icon_5.52d835b4.png";